import React, { Component } from "react";
import { connect } from "react-redux";
import _, { isEqual } from "lodash";
import { withRouter } from "react-router-dom";
import qs from "query-string";

import ConfirmationModal from "../../common/components/ConfirmationModal";
import Portal from "../../common/components/Portal";
import regionAction from "../../region/actions";
import { addToBreadCrumpData, popBreadCrumpData, findPrevPathFromBreadCrump } from "../../../config/utils";
import clientActions from "../../client/actions";
import initiativeActions from "../../initiatives/actions";
import buildingActions from "../../building/actions";
import floorAction from "../../floor/actions";
import RecommendationAction from "../../recommendations/actions";
import actions from "../actions";
import DocumentUpload from "./documentsModal";
import Iframe from "react-iframe";
import siteActons from "../../site/actions";
import exclmIcon from "../../../assets/img/recom-icon.svg";
import commonActions from "../../common/actions";
import assetActions from "../../assets/actions";
import SelectBox from "../../images/components/SelectBox";

class From extends Component {
    constructor(props) {
        super(props);
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        this.state = {
            isLoading: true,
            errorMessage: "",
            roles: "",
            reports: {
                identifier: "",
                file_name: "",
                code: "",
                file: "",
                description: "",
                document_type_id: "",
                file_type: "",
                consultancy_id: query.cty_id || "",
                client_id: query.c_id || "",
                project_id: query.p_id || "",
                region_id: query.r_id || "",
                site_id: query.s_id || "",
                building_id: query.b_id || "",
                floor_id: query.f_id || "",
                recommendation_id: query.rec_id || "",
                initiative_id: query.i_id || "",
                notes: "",
                version_no: "",
                url: ""
            },
            initiaValues: {},
            selectedDocument: props.selectedDocument || this.props.match.params.id,
            showConfirmModal: false,
            showErrorBorder: false,
            imageUploadModal: false,
            selectedImage: "",
            uploadError: "",
            attachmentChanged: false,
            selectedProjects: [],
            selectedBuildings: [],
            passwordMessage: "",
            role_name: "",
            addButton: false,
            regions: [],
            siteList: [],
            buildings: [],
            dropdownCounts: {
                project_sites: 0,
                project_buildings: 0
            },
            documentChanged: false,
            isProjectUpdated: false
        };
        this.dropdownSearchTimeout = null;
    }

    componentDidMount = async () => {
        const {
            selectedDocument,
            reports: { consultancy_id, client_id, region_id, site_id, document_type_id, building_id, project_id }
        } = this.state;
        await this.props.getAllConsultanciesDropdown();

        const {
            siteReducer: {
                getAllConsultanciesDropdownResponse: { consultancies }
            }
        } = this.props;

        if (selectedDocument) {
            await this.props.getDataById(selectedDocument);
            const {
                reportReducer: {
                    getDocumentsByIdResponse: {
                        identifier,
                        file_name,
                        code,
                        file,
                        url,
                        description,
                        document_type,
                        file_type,
                        consultancy,
                        client,
                        project,
                        region,
                        site,
                        building,
                        floor,
                        recommendation,
                        initiative,
                        notes,
                        version_no,
                        success
                    }
                }
            } = this.props;

            if (success) {
                if (consultancy && consultancy.id) {
                    this.getClientsDropDownData(consultancy?.id, client?.id);
                }
                if (client && client.id) {
                    await this.props.getAllProjectsDropdown({ client_id: client.id });
                    this.props.getAllDocuments({ client_id: client.id });
                }
                if (project && project.id) {
                    await this.loadProjectHierarchy({
                        projectId: project.id,
                        clientId: client?.id,
                        regionId: region?.id,
                        siteId: site?.id,
                        buildingId: building?.id
                    });
                }
                if (building && building.id) {
                    await this.props.getFloorBasedOnBuilding(building.id);
                }
                if (initiative && initiative.id) {
                    await this.props.getRecommendationDropdown({ project_id: project.id, initiative_id: initiative.id });
                }

                await this.setState({
                    reports: {
                        code,
                        // file: url,
                        file_id: file,
                        consultancy_id: consultancy ? consultancy.id : null,
                        client_id: client ? client.id : null,
                        identifier,
                        file_name,
                        description,
                        document_type_id: document_type ? document_type.id : null,
                        file_type,
                        project_id: project ? project.id : null,
                        region_id: region ? region.id : null,
                        site_id: site ? site.id : null,
                        building_id: building ? building.id : null,
                        floor_id: floor ? floor.id : null,
                        recommendation_id: recommendation ? recommendation.id : null,
                        initiative_id: initiative ? initiative.id : null,
                        notes,
                        version_no: version_no,
                        url
                    },
                    selectedImage: url
                });
            }
        } else {
            if (consultancy_id) {
                this.getClientsDropDownData(consultancy_id, client_id);
            }
            if (client_id) {
                await this.props.getAllProjectsDropdown({ client_id: this.state.reports.client_id });
                this.props.getAllDocuments({ client_id: this.state.reports.client_id });
            }
            if (project_id) {
                await this.loadProjectHierarchy({
                    projectId: project_id,
                    clientId: client_id,
                    regionId: region_id,
                    siteId: site_id,
                    buildingId: building_id
                });
            }
            if (building_id) {
                await this.props.getFloorBasedOnBuilding(building_id);
            }
        }

        await this.setState({
            initiaValues: this.state.reports,
            consultancies,
            isLoading: false
        });
    };

    componentWillUnmount = () => {
        if (this.dropdownSearchTimeout) {
            clearTimeout(this.dropdownSearchTimeout);
        }
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (prevState.reports !== this.state.reports) {
            this.checkFormDirty();
        }
    };

    checkFormDirty = () => {
        const { initiaValues, reports } = this.state;

        if (Object.keys(initiaValues)?.length) {
            const isDirty = !isEqual(reports, initiaValues);

            if (isDirty) {
                this.props.setFormDirty(true);
            } else {
                this.props.setFormDirty(false);
            }
        }
    };

    validate = () => {
        let role = localStorage.getItem("role");
        const { reports, documentChanged } = this.state;
        this.setState({
            showErrorBorder: false
        });

        if (role === "super_admin" && !reports.consultancy_id) {
            this.setState({
                showErrorBorder: true,
                addButton: false
            });
            return false;
        }
        if (role === "super_admin" && !reports.client_id) {
            this.setState({
                showErrorBorder: true,
                addButton: false
            });
            return false;
        }
        if (documentChanged && !reports.file) {
            this.setState({
                showErrorBorder: true,
                addButton: false
            });
            return false;
        }
        if (!reports.file_name) {
            this.setState({
                showErrorBorder: true,
                addButton: false
            });
            return false;
        }
        if (!reports.description) {
            this.setState({
                showErrorBorder: true,
                addButton: false
            });
            return false;
        }

        return true;
    };

    addDocument = async () => {
        // this.setState({ addButton: true });
        const { reports, documentChanged } = this.state;
        const { handleAddDocument } = this.props;
        if (this.validate()) {
            this.props.setFormDirty(false);

            await handleAddDocument(reports, documentChanged);
        }
    };

    updateDocument = async () => {
        const { reports, documentChanged } = this.state;
        const { handleUpdateDocument } = this.props;

        if (this.validate()) {
            this.props.setFormDirty(false);

            await handleUpdateDocument(reports, documentChanged);
        }
    };

    renderConfirmationModal = () => {
        const { showConfirmModal } = this.state;
        if (!showConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={"Do you want to clear and lose all changes?"}
                        message={"This action cannot be reverted, are you sure that you need to cancel?"}
                        onNo={() => this.setState({ showConfirmModal: false })}
                        onYes={this.clearForm}
                    />
                }
                onCancel={() => this.setState({ showConfirmModal: false })}
            />
        );
    };

    cancelForm = () => {
        if (_.isEqual(this.state.initiaValues, this.state.reports)) {
            this.clearForm();
        } else {
            this.setState({
                showConfirmModal: true
            });
        }
    };

    clearForm = async () => {
        const { history } = this.props;
        // this.setState({
        //     reports: {
        //         name: ""
        //     }
        // });

        await this.props.setFormDirty(false);

        if (!findPrevPathFromBreadCrump()) {
            addToBreadCrumpData({ key: "main", name: "reports", path: "/documents" });
        }

        history.push(findPrevPathFromBreadCrump() || "/documents");
        popBreadCrumpData();
    };

    isIterable = obj => {
        if (obj == null) {
            return false;
        }
        return typeof obj[Symbol.iterator] === "function";
    };
    handleAddAttachment = e => {
        this.setState({
            imageUploadModal: true
        });
    };

    handleImage = e => {};

    deleteImage = () => {
        this.setState({
            attachmentChanged: true,
            reports: {
                ...this.state.reports,
                image: null,
                img_desc: null,
                image_id: null,
                image_name: ""
            },
            selectedImage: null
        });
    };

    handleAddImage = imageData => {
        this.setState({
            uploadError: "",
            imageUploadModal: false
        });
        if (!imageData.file.url) {
            let ext = imageData.file.name.split(".").pop();
            this.setState({
                attachmentChanged: true,
                reports: {
                    ...this.state.reports,
                    file: imageData.file,
                    file_type: ext,
                    file_name: imageData.file.name
                },
                previewImage: URL.createObjectURL(imageData.file),
                documentChanged: true
            });
        } else if (imageData.comments) {
            this.setState({
                reports: {
                    ...this.state.reports,
                    img_desc: imageData.comments,
                    documentChanged: true
                }
            });
        }
    };

    handleConsultancySelect = async e => {
        this.setState({
            reports: {
                ...this.state.reports,
                consultancy_id: e.target.value,
                client_id: "",
                project_id: "",
                region_id: "",
                site_id: "",
                building_id: "",
                floor_id: "",
                recommendation_id: "",
                initiative_id: ""
            }
        });
        this.getClientsDropDownData(e.target.value);
    };

    getClientsDropDownData = async (consultancyId, clientId = "") => {
        let param = {
            consultancy_id: consultancyId
        };
        await this.props.getAllClients(param);
        const {
            getAllClientsResponse: { clients }
        } = this.props.regionReducer;
        this.setState({
            clients,
            reports: {
                ...this.state.reports,
                client_id: clientId,
                document_type_id: ""
            }
        });
    };

    getRegionDropDownData = async params => {
        await this.props.getAllRegionDropdownDocument(params);
        const {
            reportReducer: {
                getAllRegionDropdownDocument: { regions: regionList }
            }
        } = this.props;
        this.setState({
            regions: regionList
        });
    };

    getOptionById = (options, id) => {
        if (!id) return null;
        return (options || []).find(item => `${item?.id}` === `${id}`) || null;
    };

    getSiteRegionId = siteObj => siteObj?.region_id || siteObj?.region?.id || "";

    getBuildingHierarchy = buildingObj => ({
        site_id: buildingObj?.site_id || buildingObj?.site?.id || "",
        region_id: buildingObj?.region_id || buildingObj?.region?.id || ""
    });

    loadProjectHierarchy = async ({ projectId, clientId, regionId = "", siteId = "", buildingId = "" }) => {
        if (!projectId) {
            this.setState({
                regions: [],
                siteList: [],
                buildings: [],
                dropdownCounts: {
                    project_sites: 0,
                    project_buildings: 0
                }
            });
            return;
        }

        this.getRegionDropDownData({ project_id: projectId, client_id: clientId });
        this.props.getRecommendationDropdown({ project_id: projectId });
        this.props.getInitiativeDropdown({ project_id: projectId });
        this.getSiteDropDownData(regionId, {
            projectId,
            currentEntityId: siteId
        });
        this.getBuildingDropDownData(siteId, regionId, projectId, {
            currentEntityId: buildingId
        });
    };

    getSiteDropDownData = async (regionId = "", options = {}) => {
        const { projectId = this.state.reports.project_id, search = "", currentEntityId = "", shouldStoreCount = true } = options;

        if (!projectId) {
            this.setState(prevState => ({
                siteList: [],
                dropdownCounts: {
                    ...prevState.dropdownCounts,
                    project_sites: 0
                }
            }));
            return [];
        }
        await this.props.getDropdownList("project_sites", {
            project_id: projectId,
            ...(regionId ? { region_id: regionId } : {}),
            ...(search ? { search } : {}),
            ...(currentEntityId ? { current_entity_id: currentEntityId } : {})
        });
        const {
            assetReducer: {
                dropDownList: { project_sites: siteList }
            }
        } = this.props;
        this.setState(prevState => ({
            siteList,
            dropdownCounts: {
                ...prevState.dropdownCounts,
                ...(shouldStoreCount ? { project_sites: this.props?.assetReducer?.dropdownCount?.project_sites || 0 } : {})
            }
        }));
        return siteList || [];
    };

    getBuildingDropDownData = async (siteId = "", regionId = "", projectId, options = {}) => {
        const { search = "", currentEntityId = "", shouldStoreCount = true } = options;
        const resolvedProjectId = this.state.reports.project_id || projectId;

        if (!resolvedProjectId) {
            this.setState(prevState => ({
                buildings: [],
                dropdownCounts: {
                    ...prevState.dropdownCounts,
                    project_buildings: 0
                }
            }));
            return [];
        }

        await this.props.getDropdownList("project_buildings", {
            project_id: resolvedProjectId,
            ...(siteId ? { site_id: siteId } : {}),
            ...(regionId && !siteId ? { region_id: regionId } : {}),
            ...(search ? { search } : {}),
            ...(currentEntityId ? { current_entity_id: currentEntityId } : {})
        });
        const {
            assetReducer: {
                dropDownList: { project_buildings: buildings }
            }
        } = this.props;

        this.setState(prevState => ({
            buildings,
            dropdownCounts: {
                ...prevState.dropdownCounts,
                ...(shouldStoreCount ? { project_buildings: this.props?.assetReducer?.dropdownCount?.project_buildings || 0 } : {})
            }
        }));
        return buildings || [];
    };

    handleProjectSelect = async () => {
        await this.handleDropdownSelect();
    };
    handleDropdownSelect = async () => {
        const { project_id, client_id } = this.state.reports;

        await this.setState(prevState => ({
            siteList: [],
            buildings: [],
            dropdownCounts: {
                project_sites: 0,
                project_buildings: 0
            },
            isProjectUpdated: true,
            reports: {
                ...prevState.reports,
                region_id: "",
                site_id: "",
                building_id: "",
                floor_id: "",
                recommendation_id: "",
                initiative_id: ""
            }
        }));

        await this.loadProjectHierarchy({
            projectId: project_id,
            clientId: client_id
        });
    };
    handleClientChange = async id => {
        // await this.props.getAllRegionDropdownDocument({ client_id: id });
        await this.props.getAllProjectsDropdown({ client_id: this.state.reports.client_id });
        await this.props.getAllDocuments({ client_id: this.state.reports.client_id });

        // const {
        //     reportReducer: {
        //         getAllRegionDropdownDocument: { regions: regionList }
        //     }
        // } = this.props;
        this.setState({
            // regions: regionList,
            project_id: "",
            document_type_id: ""
        });
    };

    handleRegionSelect = async regionId => {
        const resolvedRegionId = regionId ?? this.state.reports.region_id;

        await this.getSiteDropDownData(resolvedRegionId, {
            projectId: this.state.reports.project_id
        });
        await this.getBuildingDropDownData("", resolvedRegionId, this.state.reports.project_id);

        this.setState(prevState => ({
            reports: {
                ...prevState.reports,
                region_id: resolvedRegionId,
                site_id: "",
                building_id: "",
                floor_id: ""
            }
        }));
    };

    handleSiteSelect = async siteId => {
        const { reports, siteList } = this.state;
        const selectedSite = this.getOptionById(siteList, siteId);
        const nextRegionId = siteId ? this.getSiteRegionId(selectedSite) || reports.region_id : reports.region_id;

        this.setState(prevState => ({
            reports: {
                ...prevState.reports,
                region_id: nextRegionId,
                site_id: siteId,
                building_id: "",
                floor_id: ""
            }
        }));

        await this.getBuildingDropDownData(siteId, nextRegionId, reports.project_id);
    };

    handleBuilding = async buildingId => {
        const { reports, buildings, siteList } = this.state;
        const selectedBuilding = this.getOptionById(buildings, buildingId);
        const buildingHierarchy = this.getBuildingHierarchy(selectedBuilding);
        const nextSiteId = buildingId ? buildingHierarchy.site_id || reports.site_id : reports.site_id;
        const fallbackSite = this.getOptionById(siteList, nextSiteId);
        const nextRegionId = buildingId ? buildingHierarchy.region_id || this.getSiteRegionId(fallbackSite) || reports.region_id : reports.region_id;

        this.setState(prevState => ({
            reports: {
                ...prevState.reports,
                region_id: nextRegionId,
                site_id: nextSiteId,
                building_id: buildingId,
                floor_id: ""
            }
        }));
        this.getSiteDropDownData(nextRegionId, {
            projectId: this.state.reports.project_id,
            currentEntityId: nextSiteId
        });
        this.getBuildingDropDownData(nextSiteId, nextRegionId, this.state.reports.project_id, {
            currentEntityId: buildingId,
            shouldStoreCount: true
        });

        if (buildingId) {
            await this.props.getFloorBasedOnBuilding(buildingId);
        }
    };

    handleHierarchyDropdownSearch = (inputValue, actionType, dropdownKey) => {
        const action = actionType?.action || actionType;
        const { dropdownCounts, reports } = this.state;
        const currentCount = dropdownCounts?.[dropdownKey] || 0;

        if (!reports.project_id || currentCount <= 40 || !["input-change", "input-blur", "input-click"].includes(action) || !inputValue) return;

        if (this.dropdownSearchTimeout) {
            clearTimeout(this.dropdownSearchTimeout);
        }

        this.dropdownSearchTimeout = setTimeout(async () => {
            const search = inputValue?.trim?.() || "";

            if (dropdownKey === "project_sites") {
                await this.getSiteDropDownData(reports.region_id, {
                    projectId: reports?.project_id,
                    search,
                    currentEntityId: reports?.site_id,
                    shouldStoreCount: false
                });
            }

            if (dropdownKey === "project_buildings") {
                await this.getBuildingDropDownData(reports?.site_id, reports?.region_id, reports?.project_id, {
                    search,
                    currentEntityId: reports.building_id,
                    shouldStoreCount: false
                });
            }
        }, 500);
    };

    handleInitiativeSelect = async () => {
        await this.props.getRecommendationDropdown({ project_id: this.state.reports.project_id, initiative_id: this.state.reports.initiative_id });
    };

    render() {
        let role = localStorage.getItem("role");
        const { initiativeDropdown, recommendationDropdown, getAllDocumentResponse } = this.props.reportReducer;
        const { getAllProjectsDropdown } = this.props.initativeReducer;

        const {
            reports,
            siteList,
            buildings,
            regions,
            dropdownCounts,
            showErrorBorder,
            consultancies,
            clients,
            addButton,
            selectedDocument,
            isProjectUpdated
        } = this.state;
        const { assetReducer: { dropDownLoading = {} } = {} } = this.props;
        let isImage = false;
        const imgExt = ["png", "jpg", "ttf", "jpeg", "svg"];
        if (this.state.reports.file_type) {
            if (imgExt.includes(this.state.reports.file_type.toLowerCase())) {
                isImage = true;
            }
        }
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);

        return (
            <React.Fragment>
                <div className="dtl-sec col-md-12">
                    <div className="tab-dtl region-mng usr-pg">
                        <div className="topper-rec-nav">
                            <ul>
                                <div className="recom-notify-img">
                                    <img src={exclmIcon} alt="" />
                                </div>
                                <li className="active pl-4">{selectedDocument ? "Edit Document" : "Add Document"}</li>
                            </ul>

                            <div className="mr-2 text-right btnOtr mt-2 mb-2">
                                <button type="button" className="btn btn-secondary btnClr" data-dismiss="modal" onClick={() => this.cancelForm()}>
                                    Cancel
                                </button>
                                {selectedDocument ? (
                                    <button type="button" className="btn btn-primary btnRgion ml-2" onClick={() => this.updateDocument()}>
                                        Update Document
                                    </button>
                                ) : (
                                    <button
                                        disabled={addButton}
                                        type="button"
                                        className="btn btn-primary btnRgion ml-2"
                                        onClick={() => this.addDocument()}
                                    >
                                        Add New Document
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className="tab-active location-sec recom-sec main-dtl p-0">
                            <form autocomplete="off">
                                <div className="otr-common-edit custom-col min-height-buil ">
                                    <div className="row m-0">
                                        <div className="col-md-8 pl-0">
                                            <div className="basic-otr">
                                                <div className="basic-dtl-otr basic-sec p-0">
                                                    <div className="col-md-4 basic-box">
                                                        <div className="codeOtr">
                                                            <h4>Identifier</h4>
                                                            <input
                                                                autoComplete="nope"
                                                                type="text"
                                                                className={`form-control custom-input`}
                                                                value={reports.identifier}
                                                                onChange={e =>
                                                                    this.setState({
                                                                        reports: {
                                                                            ...reports,
                                                                            identifier: e.target.value
                                                                        }
                                                                    })
                                                                }
                                                                placeholder="Identifier"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 basic-box">
                                                        <div className="codeOtr">
                                                            <h4>File Name *</h4>
                                                            <input
                                                                autoComplete="nope"
                                                                type="text"
                                                                className={`${
                                                                    showErrorBorder && !reports.file_name.trim().length ? "error-border " : ""
                                                                } custom-input form-control cursor-notallowed`}
                                                                value={reports.file_name}
                                                                readOnly={true}
                                                                placeholder="File Name"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 basic-box">
                                                        <div className="codeOtr">
                                                            <h4>File Type *</h4>
                                                            <input
                                                                autoComplete="nope"
                                                                type="text"
                                                                className={`${
                                                                    showErrorBorder && !reports.file_type.trim().length ? "error-border " : ""
                                                                } custom-input form-control cursor-notallowed`}
                                                                value={reports.file_type}
                                                                readOnly={true}
                                                                placeholder="File Name"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* {role === "super_admin" ? ( */}
                                                    <div className="col-md-4 basic-box">
                                                        <div className="codeOtr sel-recom-react">
                                                            <h4>Consultancy {role === "super_admin" ? "*" : ""}</h4>
                                                            <SelectBox
                                                                className={`${showErrorBorder && !reports.consultancy_id ? "error-border" : ""} ${query.cty_id ? "cursor-notallowed" : ""}`}
                                                                optionsList={consultancies}
                                                                value={reports.consultancy_id}
                                                                handleChange={val => this.handleConsultancySelect({ target: { value: val } })}
                                                                placeholder="Select"
                                                                hideLabel={true}
                                                                isClearable={false}
                                                                disabled={query.cty_id ? true : false}
                                                                skipFormControlClass
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* ) : null} */}
                                                    {/* {role === "client_user" ? null : ( */}
                                                    <div className="col-md-4 basic-box">
                                                        <div className="codeOtr sel-recom-react">
                                                            <h4>Client {role === "super_admin" ? "*" : ""}</h4>
                                                            <SelectBox
                                                                className={`${showErrorBorder && !reports.client_id ? "error-border" : ""} ${query.c_id ? "cursor-notallowed" : ""}`}
                                                                optionsList={clients}
                                                                value={reports.client_id}
                                                                handleChange={async val => {
                                                                    await this.setState({
                                                                        reports: {
                                                                            ...reports,
                                                                            document_type_id: "",
                                                                            client_id: val,
                                                                            project_id: "",
                                                                            region_id: "",
                                                                            site_id: "",
                                                                            building_id: "",
                                                                            floor_id: "",
                                                                            recommendation_id: "",
                                                                            initiative_id: ""
                                                                        }
                                                                    });
                                                                    this.handleClientChange(val);
                                                                }}
                                                                placeholder="Select"
                                                                hideLabel={true}
                                                                isClearable={false}
                                                                disabled={query.c_id || !reports?.consultancy_id ? true : false}
                                                                skipFormControlClass
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* )} */}
                                                    <div className="col-md-4 basic-box">
                                                        <div className="codeOtr sel-recom-react">
                                                            <h4>Document Type</h4>
                                                            <SelectBox
                                                                className=""
                                                                optionsList={getAllDocumentResponse?.document_types || []}
                                                                value={reports.document_type_id}
                                                                handleChange={val =>
                                                                    this.setState({
                                                                        reports: { ...reports, document_type_id: val }
                                                                    })
                                                                }
                                                                placeholder="Select"
                                                                hideLabel={true}
                                                                isClearable={false}
                                                                skipFormControlClass
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 basic-box">
                                                        <div className="codeOtr sel-recom-react">
                                                            <h4>Project </h4>
                                                            <SelectBox
                                                                className={!reports.project_id || (query.p_id ? "cursor-notallowed" : "")}
                                                                optionsList={getAllProjectsDropdown?.projects || []}
                                                                value={reports.project_id}
                                                                handleChange={async val => {
                                                                    await this.setState({
                                                                        reports: { ...reports, project_id: val }
                                                                    });
                                                                    await this.handleDropdownSelect();
                                                                }}
                                                                placeholder="Select"
                                                                hideLabel={true}
                                                                isClearable={false}
                                                                disabled={query.p_id || !reports?.client_id ? true : false}
                                                                skipFormControlClass
                                                                isLoading={this.props?.initativeReducer?.getAllProjectsDropdown?.loading ?? false}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 basic-box">
                                                        <div className="codeOtr sel-recom-react">
                                                            <h4>Region </h4>
                                                            <SelectBox
                                                                className={`${!reports.project_id || (query.r_id && reports.region_id !== "" && !isProjectUpdated) ? "cursor-notallowed" : ""}`}
                                                                optionsList={regions}
                                                                value={reports.region_id}
                                                                handleChange={async val => {
                                                                    await this.setState({
                                                                        reports: { ...reports, region_id: val }
                                                                    });
                                                                    await this.handleRegionSelect(val);
                                                                }}
                                                                placeholder="Select"
                                                                hideLabel={true}
                                                                isClearable={false}
                                                                disabled={
                                                                    !reports.project_id ||
                                                                    (query.r_id && reports.region_id !== "" && !isProjectUpdated)
                                                                }
                                                                skipFormControlClass
                                                                isLoading={this.props?.reportReducer?.getAllRegionDropdownDocument?.loading ?? false}
                                                                manufacturerCount={regions?.length ?? 0}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 basic-box">
                                                        <div className="codeOtr sel-recom-react">
                                                            <h4>Site </h4>
                                                            <SelectBox
                                                                className={`${
                                                                    !reports.project_id || (query.s_id && reports.site_id !== "" && !isProjectUpdated)
                                                                        ? "cursor-notallowed"
                                                                        : ""
                                                                } ${showErrorBorder && !reports.site_id ? "error-border" : ""}`}
                                                                optionsList={siteList}
                                                                value={reports.site_id}
                                                                handleChange={this.handleSiteSelect}
                                                                placeholder="Select"
                                                                hideLabel={true}
                                                                isClearable={false}
                                                                disabled={
                                                                    !reports.project_id || (query.s_id && reports.site_id !== "" && !isProjectUpdated)
                                                                }
                                                                isLoading={dropDownLoading?.project_sites ?? false}
                                                                hasSearchFunction={dropdownCounts?.project_sites > 40}
                                                                handleInputChange={(inputValue, actionType) =>
                                                                    this.handleHierarchyDropdownSearch(inputValue, actionType, "project_sites")
                                                                }
                                                                manufacturerCount={dropdownCounts?.project_sites ?? 0}
                                                                skipFormControlClass
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 basic-box">
                                                        <div className="codeOtr sel-recom-react">
                                                            <h4>Building </h4>
                                                            <SelectBox
                                                                className={`${
                                                                    !reports.project_id ||
                                                                    (query.b_id && reports.building_id !== "" && !isProjectUpdated)
                                                                        ? "cursor-notallowed"
                                                                        : ""
                                                                } ${showErrorBorder && !reports.building_id ? "error-border" : ""}`}
                                                                optionsList={buildings}
                                                                value={reports.building_id}
                                                                handleChange={this.handleBuilding}
                                                                placeholder="Select"
                                                                hideLabel={true}
                                                                isClearable={false}
                                                                isBuilding={true}
                                                                disabled={
                                                                    !reports.project_id ||
                                                                    (query.b_id && reports.building_id !== "" && !isProjectUpdated)
                                                                }
                                                                isLoading={dropDownLoading?.project_buildings ?? false}
                                                                hasSearchFunction={dropdownCounts?.project_buildings > 40}
                                                                handleInputChange={(inputValue, actionType) =>
                                                                    this.handleHierarchyDropdownSearch(inputValue, actionType, "project_buildings")
                                                                }
                                                                manufacturerCount={dropdownCounts?.project_buildings ?? 0}
                                                                skipFormControlClass
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 basic-box">
                                                        <div className="codeOtr sel-recom-react">
                                                            <h4>Floors </h4>
                                                            <SelectBox
                                                                className={`${!reports.building_id ? "cursor-notallowed" : ""}`}
                                                                optionsList={this.props.recommendationsReducer?.getFloorByBuilding?.floors || []}
                                                                value={reports.floor_id}
                                                                handleChange={val =>
                                                                    this.setState({
                                                                        reports: { ...reports, floor_id: val }
                                                                    })
                                                                }
                                                                placeholder="Select"
                                                                hideLabel={true}
                                                                isClearable={false}
                                                                skipFormControlClass
                                                                disabled={!reports.building_id}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 basic-box">
                                                        <div className="codeOtr sel-recom-react">
                                                            <h4>Initiative </h4>
                                                            <SelectBox
                                                                className={`${!reports.project_id || (query.i_id && reports.initiative_id !== "" && !isProjectUpdated) ? "cursor-notallowed" : ""}`}
                                                                optionsList={initiativeDropdown?.projects || []}
                                                                value={reports.initiative_id}
                                                                handleChange={async val => {
                                                                    await this.setState({
                                                                        reports: { ...reports, initiative_id: val }
                                                                    });
                                                                    await this.handleInitiativeSelect();
                                                                }}
                                                                placeholder="Select"
                                                                hideLabel={true}
                                                                isClearable={false}
                                                                disabled={query.i_id && reports.initiative_id !== "" && !isProjectUpdated}
                                                                skipFormControlClass
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 basic-box">
                                                        <div className="codeOtr sel-recom-react ">
                                                            <h4>Recommendation </h4>
                                                            <SelectBox
                                                                className={`${query.rec_id && reports.recommendation_id !== "" && !isProjectUpdated ? "cursor-notallowed" : ""}`}
                                                                optionsList={(recommendationDropdown?.recommendations || []).map(item => ({
                                                                    id: item.id,
                                                                    name: item.description // remap description → name for SelectBox
                                                                }))}
                                                                value={reports.recommendation_id}
                                                                handleChange={val =>
                                                                    this.setState({
                                                                        reports: { ...reports, recommendation_id: val }
                                                                    })
                                                                }
                                                                placeholder="Select"
                                                                hideLabel={true}
                                                                isClearable={false}
                                                                disabled={query.rec_id && reports.recommendation_id !== "" && !isProjectUpdated}
                                                                skipFormControlClass
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 basic-box">
                                                        <div className="codeOtr">
                                                            <h4>Version</h4>
                                                            <input
                                                                autoComplete="nope"
                                                                type="text"
                                                                className={`custom-input form-control `}
                                                                value={reports.version_no}
                                                                placeholder="Versioning"
                                                                onChange={async e => {
                                                                    await this.setState({
                                                                        reports: {
                                                                            ...reports,
                                                                            version_no: e.target.value
                                                                        }
                                                                    });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className={
                                                showErrorBorder && !this.state.reports.file_name
                                                    ? "col-md-4 back-set error-border"
                                                    : "col-md-4 back-set"
                                            }
                                        >
                                            <div className="details-img-block details-img-new">
                                                {this.state.selectedImage ? (
                                                    <>
                                                        {this.state.documentChanged ? (
                                                            <>
                                                                <div
                                                                    className={
                                                                        selectedDocument ? "custom-image-upload edit-addtn" : "custom-image-upload"
                                                                    }
                                                                    onClick={this.handleAddAttachment}
                                                                >
                                                                    <label for="file-input">
                                                                        {this.state.reports.file.name ? <i className="fas fa-pencil-alt"></i> : ""}
                                                                    </label>
                                                                </div>
                                                                {isImage ? (
                                                                    <img src={`${this.state.previewImage}`} alt="" />
                                                                ) : this.state.reports.file_type == "pdf" ? (
                                                                    <Iframe
                                                                        url={this.state.previewImage}
                                                                        width="100%"
                                                                        height="100%"
                                                                        display="initial"
                                                                        position="relative"
                                                                    />
                                                                ) : (
                                                                    <img src="/img/docIcon.webp" alt="" />
                                                                )}
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className="custom-image-upload edit-addtn" onClick={this.handleAddAttachment}>
                                                                    <label for="file-input">
                                                                        {this.state.reports.file_name ? <i className="fas fa-pencil-alt"></i> : ""}
                                                                    </label>
                                                                </div>
                                                                {this.state.reports.url &&
                                                                this.state.reports.file_type &&
                                                                ["png", "jpg", "ttf", "jpeg", "svg"].includes(
                                                                    this.state.reports.file_type.toLowerCase()
                                                                ) ? (
                                                                    <img src={`${this.state.selectedImage}`} alt="" />
                                                                ) : this.state.reports.url &&
                                                                  this.state.reports.file_type &&
                                                                  (this.state.reports.file_type == "pdf" || this.state.reports.file_type == "PDF") ? (
                                                                    <>
                                                                        <Iframe
                                                                            url={this.state.reports.url}
                                                                            width="100%"
                                                                            height="100%"
                                                                            display="initial"
                                                                            position="relative"
                                                                        />
                                                                    </>
                                                                ) : (
                                                                    <img src="/img/docIcon.webp" alt=""></img>
                                                                )}
                                                            </>
                                                        )}
                                                    </>
                                                ) : (
                                                    <>
                                                        {this.state.previewImage ? (
                                                            <>
                                                                <div className="custom-image-upload edit-addtn" onClick={this.handleAddAttachment}>
                                                                    <label for="file-input">
                                                                        {this.state.reports.file && this.state.reports.file.name ? (
                                                                            <i className="fas fa-pencil-alt"></i>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </label>
                                                                </div>
                                                                {this.state.reports.file_type == "pdf" ? (
                                                                    // <img
                                                                    //     src="/img/pdfIcon.jpeg"/>
                                                                    <Iframe
                                                                        url={this.state.previewImage}
                                                                        width="100%"
                                                                        height="100%"
                                                                        display="initial"
                                                                        position="relative"
                                                                    />
                                                                ) : isImage ? (
                                                                    <img src={`${this.state.previewImage}`} alt="" />
                                                                ) : (
                                                                    <img src="/img/docIcon.webp" alt="" />
                                                                )}
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div
                                                                    className="custom-image-upload  cstm-width-btn "
                                                                    onClick={this.handleAddAttachment}
                                                                >
                                                                    <label for="file-input">Add Document</label>
                                                                </div>
                                                                <img src="/img/no-image.png" alt="" />
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="basic-otr mt-3 new-sec">
                                        <div className="basic-dtl-otr basic-sec pl-0 pr-0">
                                            <div className="col-md-4 basic-box comment-form">
                                                <div className="codeOtr">
                                                    <h4>Description*</h4>
                                                    <textarea
                                                        autoComplete="nope"
                                                        className={`${
                                                            showErrorBorder && !reports.description.trim().length ? "error-border " : ""
                                                        } custom-input form-control`}
                                                        onChange={async e => {
                                                            await this.setState({
                                                                reports: {
                                                                    ...reports,
                                                                    description: e.target.value
                                                                }
                                                            });
                                                        }}
                                                        value={reports.description}
                                                    ></textarea>
                                                </div>
                                            </div>
                                            <div className="col-md-4 basic-box comment-form">
                                                <div className="codeOtr">
                                                    <h4>Notes</h4>
                                                    <textarea
                                                        autoComplete="nope"
                                                        className={`custom-input form-control`}
                                                        onChange={async e => {
                                                            await this.setState({
                                                                reports: {
                                                                    ...reports,
                                                                    notes: e.target.value
                                                                }
                                                            });
                                                        }}
                                                        value={reports.notes}
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    {/* </div> */}
                    {this.state.imageUploadModal ? (
                        <>
                            <Portal
                                body={
                                    <DocumentUpload
                                        imageList={
                                            !this.state.documentChanged
                                                ? [{ name: this.state.reports.file_name, url: this.state.reports.url }]
                                                : this.state.reports.file
                                                  ? [this.state.reports.file]
                                                  : []
                                        }
                                        img_desc={this.state.reports.img_desc ? this.state.reports.img_desc : ""}
                                        isRecomentaionView={true}
                                        handleImage={this.handleImage}
                                        handleAddImage={this.handleAddImage}
                                        file_name={this.state.reports.file_name}
                                        deleteImageRecomention={this.deleteImage}
                                        onCancel={() =>
                                            this.setState({
                                                imageUploadModal: false
                                            })
                                        }
                                    />
                                }
                                onCancel={() =>
                                    this.setState({
                                        imageUploadModal: false
                                    })
                                }
                            />{" "}
                        </>
                    ) : null}
                </div>
                {this.renderConfirmationModal()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    const {
        clientReducer,
        regionReducer,
        siteReducer,
        reportReducer,
        initativeReducer,
        buildingReducer,
        floorReducer,
        recommendationsReducer,
        assetReducer
    } = state;
    return {
        clientReducer,
        regionReducer,
        siteReducer,
        reportReducer,
        initativeReducer,
        buildingReducer,
        floorReducer,
        recommendationsReducer,
        assetReducer
    };
};
const { setFormDirty } = commonActions;

export default withRouter(
    connect(mapStateToProps, {
        ...assetActions,
        ...siteActons,
        ...clientActions,
        ...RecommendationAction,
        ...actions,
        ...floorAction,
        ...regionAction,
        ...initiativeActions,
        ...buildingActions,
        setFormDirty
    })(From)
);
